<!-- components/iframe-keep-alive.vue -->
<script lang="ts" setup>
const route = useRoute()

// 缓存 { path, component }，component 是封装了 iframe 的 Vue 组件
const iframeComponents = ref<{ path: string, component: any }[]>([])

// 动态加载组件
async function getComponent(loader: () => Promise<any>) {
  const mod = await loader()
  return mod.default || mod
}

// 监听路由变化，动态加载并缓存 iframe 页面组件
watchEffect(async () => {
  const isIframe = !!route.meta.isIframe
  if (!isIframe)
    return
  const modules = import.meta.glob('@/views/**/*.vue')
  const componentLoader = modules[`/src/views${route.meta.isIframe}`] // 路由的组件加载器

  if (isIframe && componentLoader) {
    // 检查是否已缓存
    const exists = iframeComponents.value.find(item => item.path === route.path)
    if (!exists) {
      try {
        // 动态加载组件（这个组件内部包含 <iframe :src="..." />）
        const Comp = await getComponent(componentLoader)
        // 使用 markRaw 防止被响应式代理
        iframeComponents.value.push({
          path: route.path,
          component: markRaw(Comp),
        })
      }
      catch (err) {
        console.error(`Failed to load iframe component for ${route.path}`, err)
      }
    }
  }
})
</script>

<template>
  <!-- 遍历所有缓存的 iframe 组件 -->
  <template v-for="item in iframeComponents" :key="item.path">
    <!-- 使用 v-show 控制显隐，不销毁组件 -->
    <component
      :is="item.component"
      v-show="item.path === $route.path"
    />
  </template>
</template>
